import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../redux';
import { Item } from '../../../redux/api/types';

type ItemNameProps = {
  readonly isCustomer: boolean;
  readonly item: Item;
};

const itemTextStyle = {
  color: '#1A1919',
  fontSize: 14,
  fontWeight: 500,
  marginLeft: 12,
  marginRight: 12,
};

const getColor = (isCurrent: boolean) => {
  return isCurrent ? '#1C5BFE' : '#1A1919';
};

function ItemName({ isCustomer, item }: ItemNameProps) {
  const context = useSelector((state: RootState) => state.api.context);

  let isCurrent = false;
  if (context) {
    if (isCustomer && context.enforce === 'customer') {
      isCurrent = item.uuid === context.customer_uuid;
    }
    if (!isCustomer && context.enforce === 'customer_group') {
      isCurrent = item.uuid === context.customer_group_uuid;
    }
  }

  return (
    <span
      className="item-name"
      style={{ ...itemTextStyle, color: getColor(isCurrent) }}
    >
      {item.name}
    </span>
  );
}

export default ItemName;
